export const themes = ['dark', 'light'];
